import { FC, ReactNode } from "react"

export interface IButtonLabelProps {
	children: ReactNode
}

export const ButtonLabel: FC<IButtonLabelProps> = (props) => {
	return props.children
}
